'use es6';

export const PERSIST_RESOLVED_REPORT = 'PERSIST_RESOLVED_REPORT';
export const REQUESTED_DATA_CHECK = 'REQUESTED_DATA_CHECK';
export const RECEIVED_DATA_CHECK = 'RECEIVED_DATA_CHECK';
export const REPORT_RESOLVED = 'REPORT_RESOLVED';